import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { WidgetConfig } from '../types'

const initialState: Omit<WidgetConfig, 'locationTypes'> & {
  ready: boolean
  mapsError: Error | null
} = {
  mapsApiKey: '',
  ready: false,
  redirectBaseUrl: '',
  mapsError: null,
  microchurchSlug: '',
  placeholderImageUrl: '',
  privacyPageUrl: '',
  continents: [],
  locations: []
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(
      _state,
      action: PayloadAction<Omit<typeof initialState, 'ready' | 'mapsError'>>
    ) {
      return {
        ...action.payload,
        ready: true,
        mapsError: null
      }
    },
    setMapsError(state, action: PayloadAction<Error>) {
      state.mapsError = action.payload
    }
  }
})

export const configActions = configSlice.actions
